

export const semesters = [{
    key:1,
    title:"Semester 1",
    name:"Semester1",
    val:"",
    act:"",
},
{
    key:2,
    title:"Semester 2",
    name:"Semester2",
    val:"",
    act:"",
},
{
    key:3,
    title:"Semester 3",
    name:"Semester3",
    val:"",
    act:"",
},
{
    key:4,
    title:"Semester 4",
    name:"Semester4",
    val:"",
    act:"",
},
{
    key:5,
    title:"Semester 5",
    name:"Semester5",
    val:"",
    act:"",
},
{
    key:6,
    title:"Semester 6",
    name:"Semester6",
    val:"",
    act:"",
},];


const courses = [
    
    /* Add more as needed...

    {
      id: 1,
      title: "Course 1 - 'A' Slot",
      name: "Course1",
      placeholder: "Credits",
      value: "",
      action: "",
      grade: "Course1",
    },
    {
      id: 2,
      title: "Course 2 - 'B' Slot",
      name: "Course2",
      placeholder: "Credits",
      value: "",
      action: "",
      grade: "Course2",
    },
    {
      id: 3,
      title: "Course 3 - 'C' Slot",
      name: "Course3",
      placeholder: "Credits",
      value: "",
      action: "",
      grade: "Course3",
    },*/

    {
        key:1,
        title:"Course 1",
        name:"Course1",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course1",
    },
    {
        key:2,
        title:"Course 2",
        name:"Course2",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course2",
    },
    {
        key:3,
        title:"Course 3",
        name:"Course3",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course3",
    },
    {
        key:4,
        title:"Course 4",
        name:"Course4",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course4",
    },
    {
        key:5,
        title:"Course 5",
        name:"Course5",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course5",
    },
    {
        key:6,
        title:"Course 6",
        name:"Course6",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course6",
    },
    {
        key:7,
        title:"Course 7",
        name:"Course7",
        pholder:"Credits",
        val:"",
        act:"",
        grade:"Course7",
    },
];

export default courses;

